import Bowser from "bowser";
const is = require("is_js");

const browser = Bowser.getParser(window.navigator.userAgent);

const state = {
  client: {
    isMobile: false,
    isTablet: false,
    isTouchDevice: false,
    browser: "",
    // os: "",
    sizes: {
      w: window.innerWidth,
      h: window.innerHeight
    },
    scrollLocked: false
  }
};

const mutations = {
  SET_MOBILE(state, payload) {
    state.client.isMobile = payload;
  },
  SET_TABLET(state, payload) {
    state.client.isTablet = payload;
  },
  SET_TOUCH_DEVICE(state, payload) {
    state.client.isTouchDevice = payload;
  },
  SET_BROWSER(state, payload) {
    state.client.browser = payload;
  },
  SET_OS(state, payload) {
    state.client.os = payload;
  },
  SET_CLIENT_W(state, payload) {
    state.client.sizes.w = payload;
  },
  SET_CLIENT_H(state, payload) {
    state.client.sizes.h = payload;
  }
};

const actions = {
  setIsMobile: ({ commit }, payload) => {
    commit("SET_MOBILE", payload);
  },
  setIsTablet: ({ commit }, payload) => {
    commit("SET_TABLET", payload);
  },
  setIsTouchDevice: ({ commit }, payload) => {
    commit("SET_TOUCH_DEVICE", payload);
  },
  setBrowser: ({ commit }, payload) => {
    commit("SET_BROWSER", payload);
  },
  setOs: ({ commit }, payload) => {
    commit("SET_OS", payload);
  },
  setW: ({ commit }, payload) => {
    commit("SET_CLIENT_W", payload);
  },
  setH: ({ commit }, payload) => {
    commit("SET_CLIENT_H", payload);
  },
  setInitial: ({ commit }, payload) => {

    //set mobile or not
    if(is.mobile()){
      commit("SET_MOBILE", true);
    }else{
      commit("SET_MOBILE", false);
    }

    if(is.tablet()){
      commit("SET_TABLET", true);
    }else{
      commit("SET_TABLET", false);
    }

    if(is.touchDevice()){
      commit("SET_TOUCH_DEVICE", true);
    }else{
      commit("SET_TOUCH_DEVICE", false);
    }

    //set browser
    commit("SET_BROWSER", browser.getBrowser());

    //dimensions
    commit("SET_CLIENT_W", window.innerWidth);
    commit("SET_CLIENT_H", window.innerHeight);
  }
};

const getters = {
  clientIsMobile: state => state.client.isMobile,
  clientIsTablet: state => state.client.isTablet,
  clientIsTouchDevice: state => state.client.isTouchDevice,
  clientBrowser: state => state.client.browser,
  clientOs: state => state.client.os,
  clientW: state => state.client.sizes.w,
  clientH: state => state.client.sizes.h
};

export default {
  state,
  mutations,
  actions,
  getters
};
